// Story 15.6 — the super_admin org detail read (Screen 24).
//
// ONE payload feeds every card on the page (Organization / Contract / Contacts /
// Members), on the shipped `useAdminUserDetail` shape.
//
// `adminOrgDetailQueryKey` is EXPORTED and its name is a cross-story contract:
// Stories 15.2 and 15.3 each invalidate the detail key after their own mutation
// and both explicitly reject re-spelling it as a local literal
// (`["admin-org", organizationId]`). Do not rename it and do not make it
// file-local — without the export their only remaining option is the one their
// own boundary rows forbid.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { AdminOrgDetail } from "@/hooks/queries/admin-orgs-types";

export const ADMIN_ORG_QUERY_KEY = "admin-org";

export function adminOrgDetailQueryKey(organizationId: string) {
  return [ADMIN_ORG_QUERY_KEY, organizationId] as const;
}

export function adminOrgDetailPath(organizationId: string): string {
  return `/admin/orgs/${encodeURIComponent(organizationId)}`;
}

export function useAdminOrgDetail(organizationId: string) {
  return useQuery({
    queryKey: adminOrgDetailQueryKey(organizationId),
    queryFn: () => apiFetch<AdminOrgDetail>(adminOrgDetailPath(organizationId)),
    // A 404 (organization_not_found, un-coded) and a 403 are both terminal;
    // the screen renders the mapped banner rather than spinning through retries.
    retry: false,
  });
}
